import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { bulkCreateAssetTypes } from "../services/assetTypeService";
import "../styles/AssetTypes.css";

const AssetTypeBulkUploadPage = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const downloadSampleCsv = () => {
    const csv = "name,description\nLaptop,Company laptop\nMonitor,External display\n";
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = "asset_types_sample.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setError("");

    if (!selectedFile) {
      setFile(null);
    } else if (!selectedFile.name.toLowerCase().endsWith(".csv")) {
      setFile(null);
      setError("Please select a CSV file (.csv).");
    } else {
      setFile(selectedFile);
    }
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!file) {
      setError("Please choose a CSV file before uploading.");
      return;
    }

    setUploading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("file", file);
      await bulkCreateAssetTypes(formData);
      navigate("/asset-types", { state: { uploadSuccess: "Asset types uploaded successfully." } });
    } catch (requestError) {
      const messages = requestError.response?.data?.messages;
      setError(messages?.join(", ") || requestError.response?.data?.message || "Unable to upload asset types. Check the CSV columns and values.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="asset-types-container asset-type-upload-page">
      <div className="asset-types-header">
        <h1>Upload Asset Types</h1>
        <Link to="/asset-types" className="btn btn-secondary">
          Back to Asset Types
        </Link>
      </div>

      <div className="upload-instructions">
        <p>
          Upload a CSV with the required <strong>name</strong> column and optional <strong>description</strong> column.
        </p>
        <button type="button" className="btn btn-secondary" onClick={downloadSampleCsv}>
          Download Sample CSV
        </button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <form className="asset-type-upload-form" onSubmit={handleUpload}>
        <div className="form-group">
          <label htmlFor="asset-type-csv">CSV file</label>
          <input id="asset-type-csv" type="file" accept=".csv,text/csv" onChange={handleFileChange} disabled={uploading} />
          {file && <p className="small">Selected: {file.name}</p>}
        </div>
        <button type="submit" className="btn btn-primary" disabled={uploading || !file}>
          {uploading ? (
            <>
              <span className="button-spinner" aria-hidden="true" />
              Uploading...
            </>
          ) : (
            "Upload Asset Types"
          )}
        </button>
      </form>
    </div>
  );
};

export default AssetTypeBulkUploadPage;
